/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AddSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const addSyncEntity = (request:AddSyncEntityRequest, options?: CashRequestOptions) => post<AddSyncEntityRequest, AddSyncEntityResponse>("/2.0/cash/add-sync-entity", request, {...options, rejectOnError: true })